<template>
<div style="padding:15px">

  <a-month-picker :allowClear="false" :disabledDate="disabledDate" :defaultValue="this.$moment(targetMonth, 'YYYY/MM')" @change="onTargetMonthChange" format="YYYY/MM" style="padding:15px 0px;width:50%;float:left" />
  <a-tooltip defaultVisible :visible="editinfo.comment && editinfo.status==='rejected'">
    <template slot='title'>
        <p>{{editinfo.comment}}</p>
      </template>
    <a-tag :color="staColor" v-if="editinfo.status" style="margin:15px;padding:5px;height:100%">{{status}}</a-tag>
  </a-tooltip>

  <a-spin :spinning="isLoading">
    <a-form :form="form" @submit="onSubmit">
      <a-form-item label="有効期間">
        <a-range-picker :allowClear="false" v-decorator="['dateRange']" format="YYYY/MM/DD" :disabled="disabledForm" />
      </a-form-item>
      <a-form-item label="利用区間">
        <a-form-item :style="{display:'inline-block',width:'calc(40%)',float:'left'}">
          <a-input v-decorator="['stationfrom']" :disabled="disabledForm" placeholder="未設定" />
        </a-form-item>
        <span :style="{display:'inline-block',float:'left'}">~</span>
        <a-form-item :style="{display:'inline-block',width:'calc(40%)',float:'left'}">
          <a-input v-decorator="['stationto']" :disabled="disabledForm" placeholder="未設定" />
        </a-form-item>
      </a-form-item>
      <a-form-item label="金額">
        <a-input-number :disabled="disabledForm" v-decorator="['price']" style="float:left;width:50%" :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')" :parser="value => value.replace(/\￥\s?|(,*)/g, '')" @change="onChange" />
      </a-form-item>
      <!-- <a-card v-for="(k, index) in form.getFieldValue('extras')" style="padding:0px;margin:0px">
        <a-form-item :required="false">
          <span :style="{display:'inline-block',float:'left'}">区間：</span>
          <a-form-item :style="{display:'inline-block',width:'calc(40%)',float:'left'}">
            <a-input v-decorator="[`extras[${k}].from`,{validateTrigger: ['change', 'blur'],preserve: true,
              rules: [{
                required: true,
                message: 'can not be null.',
              }],
            }]" />
          </a-form-item>
          <span :style="{display: 'inline-block', textAlign:'center',float:'left'}">~</span>
          <a-form-item :style="{display:'inline-block',width:'calc(40%)',float:'left'}">
            <a-input v-decorator="[`extras[${k}].to`,{validateTrigger: ['change', 'blur'],preserve: true,
              rules: [{
                required: true,
                message: 'can not be null.',
              }],
            }]" />
          </a-form-item>
        </a-form-item>
        <a-form-item>
          <span :style="{display:'inline-block',float:'left'}">金額：</span>
          <a-input-number v-decorator="[`extras[${k}].price`,{validateTrigger: ['change', 'blur'],preserve: true,
            rules: [{
              required: true,
              message: 'can not be null.',
            }],
          }]" style="float:left;" :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')" :parser="value => value.replace(/￥\s?|(,*)/g, '')" />
        </a-form-item>
        <a-button type="danger" style="width:100%" @click="() => remove(k)">削除</a-button>
        </a-card>-->
      <!-- <a-form-item style="margin-top:10px;">
        <a-button type="dashed" style="width: 100%" @click="add">
          <a-icon type="plus" />追加交通費</a-button>
        </a-form-item>-->
      <a-form-item>
        <a-button :disabled="disabledForm" style="width:100%;margin-top:15px" type="primary" html-type="submit">提出</a-button>
      </a-form-item>
    </a-form>
  </a-spin>
  <a-divider orientation="left">過去分</a-divider>
  <a-spin :spinning="isLoading">
    <a-list bordered :dataSource="listdata" size="small" itemLayout="vertical">
      <a-list-item slot="renderItem" slot-scope="item, index">
        <a-list-item-meta>
          <span slot="title">No.{{index}} {{item.targmonth}}</span>
          <span slot="description">
        {{item.statusex}}
          </span>
        </a-list-item-meta>
        {{item.datefrom}}～{{item.dateto}}
        <br>{{item.stationfrom}}～{{item.stationto}}
        <br>￥{{item.price}}
      </a-list-item>
    </a-list>
  </a-spin>
</div>
</template>
<script>
export default {
  name: "TransExp",
  props: ["eid"],
  created() {
    this.targetMonth = this.$moment().format("YYYY/MM");
    console.log("targetMonth:" + this.targetMonth);
    this.form = this.$form.createForm(this, {
      onFieldsChange: (_, changedFields) => {
        this.$emit("change", changedFields);
      },
      mapPropsToFields: () => {
        return {
          dateRange: this.$form.createFormField({
            value: (this.editinfo.datefrom && this.editinfo.dateto) ? [
              this.$moment(this.editinfo.datefrom, "YYYY/MM/DD"),
              this.$moment(this.editinfo.dateto, "YYYY/MM/DD")
            ] : null
          }),
          stationfrom: this.$form.createFormField({
            value: this.editinfo.stationfrom
          }),
          stationto: this.$form.createFormField({
            value: this.editinfo.stationto
          }),
          price: this.$form.createFormField({
            value: this.editinfo.price
          })
        };
      },
      onValuesChange: (_, values) => {
        this.$logger.d("EditInfo", "onValuesChange", {
          values: values
        });
      }
    });

    //TODO EXTRA
    // this.form.getFieldDecorator('extras', {
    //   initialValue: [],
    //   preserve: true
    // })
  },
  mounted() {
    this.loadData();
  },
  computed: {
    status: {
      get: function() {
        return this.statusex(this.editinfo.status)
      }
    },
    staColor: {
      get: function() {
        return this.editinfo.status === "comitted" ? "gray" :
          this.editinfo.status === "confirmed" ? "green" : "red";
      }
    },
    disabledForm: {
      get: function() {
        return this.editinfo.status === "confirmed" ? true : false;
      }
    }
  },
  data() {
    return {
      isLoading: true,
      targetMonth: "",
      listdata: [],
      extid: 100000,
      editinfo: {
        status: "",
        comment: "",
        datefrom: "",
        dateto: "",
        stationfrom: "",
        stationto: "",
        price: ""
      }
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        this.$logger.d("TransExp", "onSubmit", {
          err: err,
          values: values
        });
        if (!err) {
          let token = this.$store.getters.token;
          let info = this.$store.getters.info;
          this.$api.transexp.update({
              eid: info.eid,
              targmonth: this.targetMonth,
              datefrom: values.dateRange[0].format('YYYY/MM/DD'),
              dateto: values.dateRange[1].format('YYYY/MM/DD'),
              stationfrom: values.stationfrom,
              stationto: values.stationto,
              price: values.price,
              token: token
            })
            .then(data => {
              let resp = data.data;
              this.$logger.d("TransExp", "onSubmit.update", {
                response: resp
              });
              if (resp.error) {
                // this.$notification.error({
                //   message: "エラー:" + resp.error.code,
                //   description: resp.error.description
                // });
                this.$error_handler(this,resp.error)
              } else {
                this.$notification.success({
                  message: "提出しました"
                });
                this.loadData();
              }
            })
            .catch(err => {
              this.$logger.e("TransExp", "api", {
                error: err
              });
              this.$notification.error({
                message: "エラー",
                description: "サーバ通信エラー"
              });
            });
        }
      });
    },
    statusex(status) {
      if (status === "comitted") {
        return "提出済";
      } else if (status === "confirmed") {
        return "承認済";
      } else if (status === "rejected") {
        return "拒否";
      } else {
        return "未提出"
      }
    },
    loadData() {
      this.isLoading = true;
      this.listdata = []
      let token = this.$store.getters.token;
      let info = this.$store.getters.info;
      this.$api.transexp
        .query({
          eid: info.eid,
          token: token
        })
        .then(data => {
          let resp = data.data;
          this.$logger.d("TransExp", "loadData", {
            response: resp
          });
          if (resp.error) {
            // this.$notification.error({
            //   message: "エラー:" + resp.error.code,
            //   description: resp.error.description
            // });
            this.$error_handler(this,resp.error)
          } else {
            if (resp.result.transexps.length > 0) {
              this.listdata = resp.result.transexps
              this.listdata.sort((a, b) => {
                return this.$moment(a.targmonth).isAfter(b.targmonth) ? -1 : 1;
              }).forEach((el) => {
                el.statusex = this.statusex(el.status)
              })
            } else {
              this.listdata = []
            }
          }
          this.isLoading = false;
          this.loadTargData(this.targetMonth)
        })
        .catch(err => {
          this.$logger.e("TransExp", "api", {
            error: err
          });
          this.$notification.error({
            message: "エラー",
            description: "サーバ通信エラー"
          });
          this.isLoading = false;
        });
    },
    loadTargData(targetMonth) {
      let targdatas = this.listdata.filter(d => d.targmonth === targetMonth)
      console.log(targetMonth)
      if (targdatas.length > 0) {
        let targdata = targdatas[0]
        console.log("targetMonth:" + targetMonth)
        console.log("targdata:" + JSON.stringify(targdata))
        this.editinfo.status = targdata.status;
        this.editinfo.comment = targdata.comment;
        this.editinfo.datefrom = targdata.datefrom;
        this.editinfo.dateto = targdata.dateto;
        this.editinfo.stationfrom = targdata.stationfrom;
        this.editinfo.stationto = targdata.stationto;
        this.editinfo.price = targdata.price;
      } else {
        this.editinfo.status = "";
        this.editinfo.comment = "";
        this.editinfo.datefrom = "";
        this.editinfo.dateto = "";
        this.editinfo.stationfrom = "";
        this.editinfo.stationto = "";
        this.editinfo.price = "";
      }

      this.form.setFieldsValue({
        dateRange: (this.editinfo.datefrom && this.editinfo.dateto) ? [
          this.$moment(this.editinfo.datefrom, "YYYY/MM/DD"),
          this.$moment(this.editinfo.dateto, "YYYY/MM/DD")
        ] : null,
        stationfrom: this.editinfo.stationfrom,
        stationto: this.editinfo.stationto,
        price: this.editinfo.price
      });
    },
    onTargetMonthChange(value) {
      console.log("onTargetMonthChange", value);
      this.targetMonth = value.format("YYYY/MM");
      this.loadTargData(this.targetMonth)
      // this.form.setFieldsValue({
      //   dateRange: (this.editinfo.datefrom && this.editinfo.dateto) ? [
      //     this.$moment(this.editinfo.datefrom, "YYYY/MM/DD"),
      //     this.$moment(this.editinfo.dateto, "YYYY/MM/DD")
      //   ] : null,
      //   stationfrom: this.editinfo.stationfrom,
      //   stationto: this.editinfo.stationto,
      //   price: this.editinfo.price
      // });
      // this.loadData();
    },
    disabledDate(current) {
      // can not select days before today and today
      return current && current.valueOf() > Date.now();
    },
    clearExt() {
      form.setFieldsValue({
        extras: {}
      });
    },
    rmExt(key) {
      let extras = this.form.getFieldValue("extras");
      form.setFieldsValue({
        extras: extras.filter(ext => ext.id !== key.id)
      });
    },
    addExt(ext) {
      let extras = this.form.getFieldValue("extras");
      let a = extras.concat({
        id: this.extid++
      });
      form.setFieldsValue({
        extras: a
      });
    },
    remove(k) {
      const {
        form
      } = this;
      const keys = form.getFieldValue("extras");
      form.setFieldsValue({
        extras: keys.filter(key => key.id !== k.id)
      });
    },
    add() {
      const {
        form
      } = this;
      const keys = form.getFieldValue("extras");
      const nextKeys = keys.concat({
        id: extid
      });
      form.setFieldsValue({
        extras: nextKeys
      });
    },
    onChange(value) {
      console.log("changed", value);
    }
  }
};
</script>

<style scoped>
.ant-form-item {
  margin: 0 0;
}

.ant-steps-item {
  text-align: left;
  margin: 0px;
  padding: 0px;
}
</style>
